import React, { useEffect, useState } from 'react'
import { formatPhoneNumber, formatPhoneNumberIntl } from 'react-phone-number-input'
import SplitDropModal from './split-drop-modal'
import ConfirmRefundModal from './confirm-refund-modal'
import SelectInput from './inputs/select-input'

export default function GameDrops({game, drops, onLoad, onShowPlayer, onSplitDrop}) {
  const [showSplit, setShowSplit] = useState(false)
  const currencyName = game.currency == 'usd' ? '' : ` (${game.currency.toUpperCase()})`
  const [refundedDrop, setRefundedDrop] = useState(false)

  useEffect(() => {
    onLoad()
  }, [])

  if (!drops) return <div className='animated-spinner'></div>

  const formattedPhone = drop => {
    return drop.country_code && drop.country_code.toLowerCase() != 'us' ? formatPhoneNumberIntl(drop.phone) : formatPhoneNumber(drop.phone)
  }

  const title = (drop) => {
    return drop.player + ` - ${formattedPhone(drop)}`
  }

  const editDrop = (category, drop) => {
    if (category == 'refund') setRefundedDrop(drop)
    else onSplitDrop({id: drop.id, categories: [[drop.category, 0],[category, drop.amount]]})
  }

  const refundDrop = () => {
    onSplitDrop({id: refundedDrop.id, categories: [[refundedDrop.category, 0],['refund', refundedDrop.amount]]})
    cancelConfirm()
  }

  const cancelConfirm = () => {
    setRefundedDrop(false)
  }

  const splitDrop = (split, dropId) => {
    setShowSplit(false)
    onSplitDrop({id: dropId, categories: split})
  }

  return <table className='table table-striped'>
    <thead>
    <tr>
      <th>Player</th>
      <th>Time</th>
      <th>{`Paid amount${currencyName}`}</th>
      <th></th>
      <th>Category</th>
    </tr>
    </thead>
    <tbody>
      {refundedDrop && <ConfirmRefundModal onClose={cancelConfirm} onSubmit={refundDrop} />}
      {
        drops.map(drop => {
          return <tr key={drop.id}>
            { showSplit == drop.id &&
              <SplitDropModal
                drop={drop}
                onSubmit={e => splitDrop(e,drop.id)}
                onClose={() => setShowSplit(false)}
              />
            }
            <td
              className='drop-title'
              onClick={() => onShowPlayer(drop.player_id)}>
                <a className='clickable'>{title(drop)}</a>
            </td>
            <td>{moment(drop.time).tz(drop.timezone).format('MM/DD/YYYY LT')}</td>
            <td>${drop.amount}</td>
            <td>
              {drop.category && drop.category != 'refund' && !drop.locked &&
                <img className='split-icon' src='/images/call-split.svg' onClick={() => setShowSplit(drop.id)}/>
              }
            </td>
            <td>
              {drop.category && drop.category == 'refund' && drop.category}
              {drop.category && drop.category != 'refund' &&
                <SelectInput
                  disabled={drop.locked}
                  value={drop.category}
                  refund_enabled={drop.refund_enabled}
                  onChange={e => editDrop(e.target.value, drop)}
                />
              }&nbsp;
            </td>
          </tr>
        })
      }
    </tbody>
  </table>
}
